import { z } from 'zod'

export const EventTypeSchema = z.enum([
  'stdout', 'stderr', 'progress', 'info', 'warn', 'error',
  'claim', 'complete', 'fail',
])
export type EventType = z.infer<typeof EventTypeSchema>

// Codex feedback (Fix 2): Executor が `POST /api/jobs/:id/events` で直接送れる
// event_type は spec 上 4 種のみ。`warn`/`error`/`claim`/`complete`/`fail` は
// Worker 側 (lifecycle transition のときに自動 emit) が出すものなので、
// Executor 入力スキーマからは除外する。
export const ExecutorEventTypeSchema = z.enum([
  'stdout', 'stderr', 'progress', 'info',
])
export type ExecutorEventType = z.infer<typeof ExecutorEventTypeSchema>

export const JobEventSchema = z.object({
  id: z.string().uuid(),
  job_id: z.string().uuid(),
  event_type: EventTypeSchema,
  actor: z.string(),
  payload: z.record(z.unknown()),
  created_at: z.string(),
})
export type JobEvent = z.infer<typeof JobEventSchema>

export const CreateEventRequestSchema = z.object({
  event_type: ExecutorEventTypeSchema,
  actor: z.string().min(1),
  payload: z.record(z.unknown()),
})
export type CreateEventRequest = z.infer<typeof CreateEventRequestSchema>
